/**
 * Helpers for normalizing boolean-like values across inputs.
 *
 * Test View stores yes/no and checkbox answers as booleans, but API responses,
 * SDK consumers, or AI extraction utilities may send strings like "yes"/"no"
 * or numeric 1/0 values. These helpers keep everything consistent so
 * conditional logic and calculations behave exactly like the builder.
 */

const TRUE_VALUES = new Set(['true', 't', 'yes', 'y', '1', 'on']);
const FALSE_VALUES = new Set(['false', 'f', 'no', 'n', '0', 'off']);

/**
 * Normalize a value into a boolean.
 */
export function normalizeBooleanValue(value: any): boolean {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (TRUE_VALUES.has(normalized)) return true;
    if (FALSE_VALUES.has(normalized)) return false;
  }

  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }

  return Boolean(value);
}

/**
 * Convert a boolean-like value into 1/0 for scoring logic.
 */
export function booleanToNumeric(value: any): number {
  return normalizeBooleanValue(value) ? 1 : 0;
}
